import {types} from './types';

const setGetShiftAction = (payload) => {
    return {
        type: types.SET_SHIFT,
        payload,
      }
}

export {
  setGetShiftAction
}